import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class FacturamaService {
  constructor(private http: HttpClientService) {}

  public createCfdi(cfdi): Observable<any> {
    let options = {
      cfdi: cfdi,
    };
    return this.http.post("/api/cfdi", options).pipe(tap((_) => console.log("FacturamaService.createCfdi: Ok")));
  }

  public getCatalogs(): Observable<any> {
    return this.http.get("/api/cfdi/catalogs").pipe(tap((_) => console.log("FacturamaService.getCatalogs: Ok")));
  }
}
